/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Agent_Builder_Name_MaxInputs */



/**
* | output |
* | --- |
* | "The name may be at most {count} characters long." |
*
* @param {Agent_Builder_Name_MaxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_name_max = /** @type {((inputs: Agent_Builder_Name_MaxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Name_MaxInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Name darf höchstens ${i?.count} Zeichen lang sein.`)
	return /** @type {LocalizedString} */ (`The name may be at most ${i?.count} characters long.`)
});